import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Tabs from '../Tabs';
import ButtonGroup from '../ButtonGroup';

// Import CSS
import '../../assets/scss/TimeField.css';
import apiRequest from '../../handles/apiRequest';
import DownArrow from '../elements/DownArrow';

// Process time slots.
const options = ({time, isAvailable}) => ({
  label: time,
  value: time,
  disabled: !isAvailable,
});

// Export
const TimeField = ({
  onChange = () => false,
  requirement = {},
  selected = '',
  disabled = false,
}) => {
  // State
  const [tab, setTab] = useState('am');
  const [time, setTime] = useState(selected);
  const [times, setTimes] = useState({am: [], pm: []});
  const [isBox, setBox] = useState(false);

  const requirementArray = Object.values(requirement);

  useEffect(() => {
    setTime(selected);
    const hasValue = requirementArray.filter((e) => e.value !== undefined);
    if (hasValue.length === requirementArray.length) {
      apiRequest({
        method: 'GET',
        endpoint: 'available-timeslots',
        params: {
          'date': requirement.bookingDate.value,
          'branch-code': requirement.branch.value,
          'service-name': requirement.service.label,
        },
      }).then(({availableTimeslotsAM: am, availableTimeslotsPM: pm}) => {
        setTimes({am, pm});
      });
    }
  }, requirementArray);

  const handleBox = (bool) => {
    // Only display box if times are available to choose
    setBox((times.am.length + times.pm.length) ? bool : false);
  };

  const handleChange = ({target: {value}}, tab) => {
    setTime(value);
    onChange(value);
    setBox(false);
    setTab(tab);
  };

  // Display.
  const textDisplay = <div>
    <span style={{display: 'inline-block', width: '100%'}}>
      <input type="text" placeholder="" readOnly
        className="textInput btn-disabled"
        disabled={disabled || (!times.am.length && !times.pm.length)}
        onClick={() => {
          handleBox(true);
        }} name="timeSlot"
        value={time}/></span>
    <DownArrow onclick={() => {
      handleBox(true);
    }}/>
  </div>;
  const boxDisplay = <div className="time-slot">
    <Tabs active={tab === 'am' ? 0 : 1}>
      AM
      <span><ButtonGroup
        value={time} options={times.am.map(options)}
        onChange={(e) => {
          handleChange(e, 'am');
        }}/></span>
      PM
      <span><ButtonGroup
        value={time} options={times.pm.map(options)}
        onChange={(e) => {
          handleChange(e, 'pm');
        }}/></span>
    </Tabs>
  </div>;
  return <div className="row row_top">
    <div className="col-md-12">
      <span className="field-label">Preferred Time</span>
      {isBox ? boxDisplay : textDisplay}
    </div>
  </div>;
};

TimeField.propTypes = {
  onChange: PropTypes.func,
  requirement: PropTypes.object,
  selected: PropTypes.string,
  disabled: PropTypes.bool,
};

export default TimeField;
